import evaluateDispensaryFeatureFlag from 'shared/utils/evaluate-dispensary-feature-flag';

export const MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG = 'ecomm.purchase-limits.multi-subcategory.rollout';
export const CONFIGURABLE_PURCHASE_LIMITS_FLAG = 'ecomm.purchase-limits.configurable-overrides.rollout';

/**
 * Stores the raw LD value (not a coerced boolean) since apps/api evaluates this same
 * `.rollout` key as a per-dispensary JSON flag via getFeatureFlagByDispensary — reads
 * must go through the same evaluateDispensaryFeatureFlag logic or client/server can
 * desync (e.g. any truthy JSON object would read as "on" for every dispensary).
 */
let rawMultiSubcategoryFlagValue: unknown = false;
let rawConfigurablePurchaseLimitsFlagValue: unknown = false;

export function setMultiSubcategoryPurchaseLimitsFlag(value: unknown): void {
  rawMultiSubcategoryFlagValue = value;
}

export function setConfigurablePurchaseLimitsFlag(value: unknown): void {
  rawConfigurablePurchaseLimitsFlagValue = value;
}

export function isMultiSubcategoryPurchaseLimitsEnabled(dispensaryId = ''): boolean {
  return !!evaluateDispensaryFeatureFlag(
    MULTI_SUBCATEGORY_PURCHASE_LIMITS_FLAG,
    rawMultiSubcategoryFlagValue,
    dispensaryId
  );
}

export function isConfigurablePurchaseLimitsEnabled(dispensaryId = ''): boolean {
  return !!evaluateDispensaryFeatureFlag(
    CONFIGURABLE_PURCHASE_LIMITS_FLAG,
    rawConfigurablePurchaseLimitsFlagValue,
    dispensaryId
  );
}
